const envApiBaseUrl = process.env.BUN_PUBLIC_NODE_API_BASE_URL ?? ""

export const API_BASE_URL = (envApiBaseUrl ?? "").replace(/\/$/, "");

export function buildApiUrl(path: string) {
  if (!API_BASE_URL) return path;
  return `${API_BASE_URL}${path.startsWith("/") ? path : `/${path}`}`;
}